import * as CONST from 'Reducers/Roster/const'

/**
 * Create Roster
 *
 * @param callbacks
 * @param cityPlanId
 * @param payload
 * @returns {{type, callbacks: *, cityPlanId: *, payload: *}}
 */
export function createRoster(callbacks, cityPlanId, payload) {
  return {
    type: CONST.CREATE_ROSTER,
    callbacks,
    cityPlanId,
    payload,
  }
}

/**
 * update Roster
 *
 * @param callbacks
 * @param rosterId
 * @param payload
 * @returns {{type, callbacks: *, rosterId: *, payload: *}}
 */
export function updateRoster(callbacks, rosterId, payload) {
  return {
    type: CONST.UPDATE_ROSTER,
    callbacks,
    rosterId,
    payload,
  }
}

/**
 * Clear roster by id
 *
 * @returns {{type}}
 */
export function clearRosterById() {
  return {
    type: CONST.CLEAR_ROSTER_BY_ID,
  }
}

/**
 * Get roster details by roster id
 *
 * @param rosterId
 * @returns {{type, rosterId: *}}
 */
export function getRosterById(rosterId) {
  return {
    type: CONST.GET_ROSTER_BY_ID,
    rosterId,
  }
}

/**
 * Clear in state rosters by city plan id
 *
 * @returns {{type}}
 */
export function clearRostersByCityPlanId() {
  return {
    type: CONST.CLEAR_ROSTERS_BY_CITY_PLAN_ID,
  }
}

/**
 * Clear in state rosters by city plan id
 *
 * @returns {{type}}
 */
export function clearRostersByCityId() {
  return {
    type: CONST.CLEAR_ROSTERS_BY_CITY_ID,
  }
}

/**
 * Get rosters by city id
 *
 * @param cityPlanId
 * @returns {{type, cityId: *}}
 */
export function getRostersByCityId(cityId) {
  return {
    type: CONST.GET_ROSTERS_BY_CITY_ID,
    cityId,
  }
}

/**
 * Get client's rosters by cities
 *
 * @returns {{type, clientId: *}}
 */
export function getClientRostersByCities() {
  return {
    type: CONST.GET_CLIENT_ROSTERS_BY_CITIES,
  }
}

/**
 * Set rosters by city plan id status filter
 *
 * @param status
 * @returns {{type, statusFilter: string}}
 */
export function setRostersByCityPlanIdStatusFilter(status) {
  return {
    type: CONST.SET_ROSTERS_BY_CITY_PLAN_ID_STATUS_FILTER,
    statusFilter: status,
  }
}

/**
 * Delete roster by id
 *
 * @param rosterId
 * @param callbackPath
 * @returns {{type, rosterId: *, campaignId: *, cityPlanId: *}}
 */
export function deleteRosterById(rosterId, callbackPath) {
  return {
    type: CONST.DELETE_ROSTER_BY_ID,
    rosterId,
    callbackPath,
  }
}

/**
 * Update mission data and refresh rosters missions list
 *
 * @param id
 * @param payload
 * @returns {{type, id: *, payload: *}}
 */
export function updateRostersMission(id, payload) {
  return {
    type: CONST.UPDATE_ROSTERS_MISSION,
    id,
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/Roster/actions.js